export const PLAN_PERKS = {
  free:   ["Live 72-hour feed", "Up to 2 niches", "10 generations total · no reset", "Save up to 10 packets"],
  solo:   ["30 generations / month", "Daily Brief email at 06:00 UTC", "Up to 3 niches", "50 saved packets"],
  pro:    ["150 generations / month", "Daily Brief + Weekly Calendar", "Up to 8 niches", "Custom RSS feeds (15)", "Unlimited saved packets"],
  studio: ["Unlimited generations", "Daily Brief + custom send time", "Unlimited custom RSS feeds", "Unlimited niches", "Up to 5 creator profiles", "Branded email digest"],
};

export const PLAN_LABEL = { free: "Free", solo: "Solo", pro: "Pro", studio: "Studio" };

export function daysBetween(dateIso) {
  if (!dateIso) return null;
  const ms = new Date(dateIso) - new Date();
  return Math.max(0, Math.ceil(ms / (24 * 60 * 60 * 1000)));
}

export function formatDate(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return "—";
  return dt.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

export function formatMoney(amount, currency = "usd") {
  if (amount == null) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: currency.toUpperCase() }).format(amount);
}
